import React from "react";

interface UploadProgressProps {
  progress: number;
}

export const UploadProgress: React.FC<UploadProgressProps> = ({ progress }) => {
  if (progress <= 0) return null;

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "8px"
        }}
      >
        <span>업로드 진행률</span>
        <span>{progress}%</span>
      </div>
      <div
        style={{
          width: "100%",
          backgroundColor: "#e9ecef",
          borderRadius: "10px",
          overflow: "hidden",
          height: "8px"
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            backgroundColor: "#007bff",
            transition: "width 0.3s ease",
            borderRadius: "10px"
          }}
        />
      </div>
    </div>
  );
};
